import LegalLayout from "@/pages/LegalLayout";

export default function PrivacyPage() {
  return (
    <LegalLayout title="Ochrana osobných údajov" lastUpdated="9. február 2026">
      <p className="lead">
        Tieto zásady ochrany osobných údajov popisujú, ako webová aplikácia{" "}
        <strong>Real Selfie</strong> (dostupná na{" "}
        <a href="https://realselfie.eu">realselfie.eu</a>) spracúva osobné
        údaje v súlade s Nariadením (EÚ) 2016/679 (GDPR) a zákonom č. 18/2018
        Z. z. o ochrane osobných údajov.
      </p>

      <h2>1. Prevádzkovateľ údajov</h2>
      <p>
        <strong>František Varga – VFN</strong>
        <br />
        IČO: 54 175 488
        <br />
        Sídlo: Malé Blahovo, Horná 1694/43, 929 01 Dunajská Streda
        <br />
        Kontakt vo veciach ochrany údajov:{" "}
        <a href="mailto:support@realselfie.eu">support@realselfie.eu</a>
      </p>

      <h2>2. Aké údaje spracúvame</h2>

      <h3>🔒 Čo NEZBIERAME (dôležité)</h3>
      <ul>
        <li>
          <strong>Vaše fotografie</strong> — nikdy neopúšťajú vaše zariadenie.
          Sú uložené iba lokálne v prehliadači (IndexedDB) a vo zvolenom
          priečinku zariadenia.
        </li>
        <li>
          <strong>Obsah kamery</strong> — živé video z kamery sa spracúva
          výhradne vo vašom prehliadači, nie je nikam odosielané.
        </li>
        <li>
          <strong>Tvár, biometriku, polohu, kontakty</strong> — nič takéto
          nezbierame.
        </li>
        <li>
          <strong>Vaše meno, e-mail, telefón</strong> — nevyžadujeme
          registráciu ani prihlásenie.
        </li>
      </ul>

      <h3>📊 Čo zbierame</h3>
      <ul>
        <li>
          <strong>device_id</strong>: anonymný UUID identifikátor vygenerovaný
          vo vašom prehliadači pri prvom načítaní. Slúži na sledovanie počtu
          využitých fotiek v bezplatnej verzii a na priradenie Premium
          licencie k vášmu zariadeniu. Nedá sa z neho odvodiť vaša identita.
        </li>
        <li>
          <strong>photo_count</strong>: koľko fotiek ste v rámci bezplatnej
          verzie zachytili (0 až 3).
        </li>
        <li>
          <strong>Údaje o platbe</strong>: ak zakúpite Premium, spracujeme
          session_id, payment_status, čas platby a zaplatenú sumu. Údaje o
          platobnej karte spracúva výhradne Stripe — my k nim nemáme prístup.
        </li>
        <li>
          <strong>IP adresa</strong>: dočasne pri HTTP požiadavkách na server
          (na účely základnej bezpečnosti). Neukladáme ju trvalo s vaším
          device_id.
        </li>
      </ul>

      <h2>3. Účel a právny základ spracúvania</h2>
      <table>
        <thead>
          <tr>
            <th>Účel</th>
            <th>Právny základ (GDPR)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Poskytnutie bezplatnej a Premium verzie</td>
            <td>Plnenie zmluvy [čl. 6 ods. 1 písm. b)]</td>
          </tr>
          <tr>
            <td>Spracovanie platby cez Stripe</td>
            <td>Plnenie zmluvy [čl. 6 ods. 1 písm. b)]</td>
          </tr>
          <tr>
            <td>Účtovné a daňové povinnosti</td>
            <td>Plnenie zákonnej povinnosti [čl. 6 ods. 1 písm. c)]</td>
          </tr>
          <tr>
            <td>Predchádzanie zneužitiu (anti-fraud)</td>
            <td>Oprávnený záujem [čl. 6 ods. 1 písm. f)]</td>
          </tr>
        </tbody>
      </table>

      <h2>4. Sprostredkovatelia a príjemcovia údajov</h2>
      <ul>
        <li>
          <strong>Stripe Payments Europe, Ltd.</strong> (Írsko) — platobný
          procesor. Spracúva údaje o platobných kartách a platbách. Stripe
          Privacy Policy:{" "}
          <a
            href="https://stripe.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            stripe.com/privacy
          </a>
          .
        </li>
        <li>
          <strong>Cloudový hosting</strong> — backend a databáza sú hostované u
          poskytovateľa cloudových služieb v EÚ.
        </li>
      </ul>
      <p>
        Vaše údaje neprenášame mimo EÚ/EHP. Vaše údaje nepredávame tretím
        stranám.
      </p>

      <h2>5. Doba uchovávania</h2>
      <ul>
        <li>
          <strong>device_id, photo_count</strong>: do vymazania zariadeniom
          alebo do vašej žiadosti o vymazanie.
        </li>
        <li>
          <strong>Premium licencia</strong>: trvalo, kým ste Premium
          používateľ, alebo do vašej žiadosti o vymazanie.
        </li>
        <li>
          <strong>Údaje o platbách</strong>: 10 rokov od konca účtovného obdobia
          (zákon č. 431/2002 Z. z. o účtovníctve).
        </li>
      </ul>

      <h2>6. Vaše práva (GDPR)</h2>
      <p>Ako dotknutá osoba máte právo:</p>
      <ul>
        <li>
          <strong>Na prístup</strong> k vašim údajom [čl. 15]
        </li>
        <li>
          <strong>Na opravu</strong> nesprávnych údajov [čl. 16]
        </li>
        <li>
          <strong>Na vymazanie</strong> (&bdquo;právo byť zabudnutý&ldquo;) [čl. 17]
        </li>
        <li>
          <strong>Na obmedzenie</strong> spracúvania [čl. 18]
        </li>
        <li>
          <strong>Na prenosnosť</strong> údajov [čl. 20]
        </li>
        <li>
          <strong>Namietať</strong> proti spracúvaniu [čl. 21]
        </li>
        <li>
          Podať sťažnosť na <strong>Úrad na ochranu osobných údajov SR</strong>{" "}
          (
          <a href="https://www.dataprotection.gov.sk" target="_blank" rel="noopener noreferrer">
            dataprotection.gov.sk
          </a>
          )
        </li>
      </ul>
      <p>
        Žiadosti smerujte na{" "}
        <a href="mailto:support@realselfie.eu">support@realselfie.eu</a>.
        Odpovieme do 30 dní.
      </p>

      <h2>7. Deti</h2>
      <p>
        Služba nie je primárne určená osobám mladším ako 16 rokov. Vedome
        nespracúvame osobné údaje detí pod 16 rokov.
      </p>

      <h2>8. Bezpečnosť</h2>
      <p>
        Server komunikuje výhradne cez HTTPS. Údaje o platbách prebiehajú v
        zabezpečenom prostredí Stripe (PCI-DSS Level 1). Premium licencie sú
        identifikované anonymným UUID, ktorý sám o sebe neumožňuje
        identifikovať konkrétnu osobu.
      </p>

      <h2>9. Zmeny zásad</h2>
      <p>
        Aktuálna verzia týchto zásad je vždy dostupná na{" "}
        <a href="https://realselfie.eu/privacy">realselfie.eu/privacy</a>.
        Pri zásadných zmenách budú používatelia informovaní pri ďalšom otvorení
        aplikácie.
      </p>
    </LegalLayout>
  );
}
